module.exports = __webpack_public_path__ + "static/media/warning.bdcb3cc8.svg";